import { Centrifuge } from 'centrifuge'
import { storageService } from '@/services'
import { isNullOrUndefined } from '@/util/validators/baseComponentsValidators'
import { WS_CHANNELS } from '@/services/ws'

export default ({ $config, store, $sentry }, inject) => {
  let centrifuge = null
  inject('WS', {
    init: () => {

      if (centrifuge) {
        console.warn('Centrifuge: The module has already been initialized')
        return
      }
      /** Connect */
      centrifuge = new Centrifuge(`${$config.API_WS_URL}/connection/websocket`)
      centrifuge.setHeaders({
        Authorization: `Bearer ${storageService.getToken() || store.getters['user/get_guestUserToken']}`,
      })

      const userId = store.getters['user/userId']

      const context = { store, $sentry }

      WS_CHANNELS.forEach(({ channel, getName }) => {
        const subscriptionName = getName(userId)
        const handler = ({ data }) => channel.process(context, data)

        centrifuge
          .newSubscription(subscriptionName)
          .on('publication', handler)
          .subscribe()
      })

      centrifuge.connect()

    },
    disconnect: () => {
      if (isNullOrUndefined(centrifuge)) return
      centrifuge.disconnect()
      centrifuge = null
    },
  })
}
